import React from 'react';

import Slider from 'rc-slider';

import PercentageInput from './PercentageInput';
import Toggle from './Toggle';
import BasicProviderImage from '../../../../components/providerimage/BasicProviderImage';

export const LabelType = {
  PROVIDER: "provider",
  TOP: "TOP"
};

export default ({label, id, type, value, enabled, locked, active, removable, onBeforeChange, onChange, onAfterChange, onToggleLocked, onRemove}) => {
  //when flex box was implemented we decided, it was best to just keep the labels to the left
  let labelLeftContainer;
  let remove;
  let containerClasses = "slide-lock slide-child score-setting-container";
  if(!!label){
    switch(type){
      case LabelType.PROVIDER:
        containerClasses += ' label-left';
        labelLeftContainer = (<label><BasicProviderImage provider={id} /> {label}</label>);
        break;
      case LabelType.TOP:
      default:
        containerClasses += ' label-top';
        labelLeftContainer = (
          <label>{label}</label>
        );
        break;
    }
  }
  if(removable){
    remove = (<span className="clickable remove-provider" onClick={onRemove}><i className="ss-icon ss-delete" /></span>);
  }else{
    remove = (<i className="ss-icon ss-empty" />);
  }


  return (
    <div className={containerClasses}>
      <div className="title">
        {labelLeftContainer}
      </div>
      <div className="slider">
        <Slider
          className={active ? 'active' : ''}
          disabled={!enabled}
          value={value}
          onBeforeChange={onBeforeChange}
          onChange={onChange}
          onAfterChange={onAfterChange}
        />
      </div>
      <div className="icons d-flex flex-row align-items-center">
        <PercentageInput value={value} onChange={onChange} disabled={!enabled || locked} />
        <Toggle onClick={onToggleLocked} opened={enabled && !locked} openedClass="control-spacer-left fa-lock-open-alt" closedClass="control-spacer-left fa-lock-alt" />
        {remove}
      </div>
    </div>
  );
}
